import { IFilter } from "@saleor/components/Filter";
import { AutocompleteFilterOpts, FilterOpts, MinMax } from "@saleor/types";
import {
  createAutocompleteField,
  createDateField
} from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum ProductsReportsFilterKeys {
  brand = "brand",
  mall = "mall",
  tenantType = "tenantType",
  startDate = "startDate"
}
export interface ProductsReportsListFilterOpts {
  startDate: FilterOpts<MinMax>;
  brand: FilterOpts<string[]> & AutocompleteFilterOpts;
  mall: FilterOpts<string[]> & AutocompleteFilterOpts;
}

const messages = defineMessages({
  brand: {
    defaultMessage: "Brand",
    description: "brand"
  },
  foodAndBeverages: {
    defaultMessage: "Food and Beverages",
    description: "Food and Beverages"
  },
  generalMerchandise: {
    defaultMessage: "General Merchandise",
    description: "general merchandise"
  },
  grocery: {
    defaultMessage: "Grocery",
    description: "Grocery"
  },
  mall: {
    defaultMessage: "Mall Name",
    description: "mall branch"
  },

  startDate: {
    defaultMessage: "Start & End Dates",
    description: "Start & End Dates"
  },
  tenant: {
    defaultMessage: "Tenant Type",
    description: "tenant type"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: ProductsReportsListFilterOpts
): IFilter<ProductsReportsFilterKeys> {
  return [
    {
      ...createDateField(
        ProductsReportsFilterKeys.startDate,
        intl.formatMessage(messages.startDate),
        opts.startDate.value
      ),
      active: opts.startDate.active
    },
    {
      ...createAutocompleteField(
        ProductsReportsFilterKeys.brand,
        intl.formatMessage(messages.brand),
        opts.brand.value,
        opts.brand.displayValues,
        true,
        opts.brand.choices,
        {
          hasMore: opts.brand.hasMore,
          initialSearch: "",
          loading: opts.brand.loading,
          onFetchMore: opts.brand.onFetchMore,
          onSearchChange: opts.brand.onSearchChange
        }
      ),
      active: opts.brand.active
    },
    {
      ...createAutocompleteField(
        ProductsReportsFilterKeys.mall,
        intl.formatMessage(messages.mall),
        opts.mall.value,
        opts.mall.displayValues,
        true,
        opts.mall.choices,
        {
          hasMore: opts.mall.hasMore,
          initialSearch: "",
          loading: opts.mall.loading,
          onFetchMore: opts.mall.onFetchMore,
          onSearchChange: opts.mall.onSearchChange
        }
      ),
      active: opts.mall.active
    }
  ];
}
